
import RelatedContent from './RelatedContent';

RelatedContent();
